import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  ReactNode,
  RefAttributes
} from 'react';
import { SxStyleProp, Button } from 'theme-ui';
import Axios from 'axios';

type DownloadButtonProps = {
  children: ReactNode;
  href: string;
  download: string;
  sx?: SxStyleProp;
  onClick?: () => void;
};

function downloadFile(url: string, fileName: string) {
  const a = document.createElement('a');
  a.download = fileName;
  a.target = '_blank';

  Axios.get(url, { responseType: 'blob' })
    .then(res => {
      const file = new File([res.data], fileName);
      a.href = URL.createObjectURL(file);
      a.click();

      URL.revokeObjectURL(a.href);
    })
    .catch(() => {
      a.href = url;
      a.click();
    });
}

export const DownloadButton: ForwardRefExoticComponent<
  PropsWithoutRef<DownloadButtonProps> & RefAttributes<HTMLButtonElement>
> = forwardRef(({ onClick, children, href, download }, ref) => (
  <Button
    onClick={() => {
      onClick();
      downloadFile(href, download);
    }}
    ref={ref}
    variant="text"
    sx={{ textDecoration: 'underline', fontSize: 1, p: 0, fontWeight: 'body' }}
    data-test="download"
  >
    {children}
  </Button>
));
